/**
 * DATA IMPORTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getDataImportLogs,
    getDataImportLog,
    printDataImportLog,
    createDataImportLogs,
    updateDataImportLogs,
    deleteDataImportLogs,
    getDataImportTableFields,
} from "Core/configuration/data_import_logs/config/api.data_import_logs";

const state = {
    page: {},
    form: {},
    data_import_logs: [],
    selectedDataImportLog: {
        import_id: null,
        company_id: "",
        data_import_log_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        data_import_log_details: [],
    },
    data_import_logs_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_data_import_logs: {
        import_id: {
            name: "import_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        file_name: {
            name: "file_name",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        user_id: {
            name: "user_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        primary_table_id: {
            name: "primary_table_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        field_mappings: {
            field_id: {
                name: "field_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            table_id: {
                name: "table_id",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            table_name: {
                name: "table_name",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            name: {
                name: "name",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            table_field: {
                name: "table_field",
                rules: "trim|max_length[255]",
                max_len: "255",
                min_len: "",
                default_value: "",
            },
            position: {
                name: "position",
                rules: "trim|max_length[15]|integer",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
        },
        file: {
            name: "file",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    data_import_logs: (state) => {
        return state.data_import_logs;
    },
};

// actions
const actions = {
    async fetchDataImportLogs({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getDataImportLogs({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageDataImportLogs", response.data.page);
                }

                commit("setDataImportLogs", response.data.data_import_logs);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchDataImportLog({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getDataImportLog(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedDataImportLog", response.data.data_import_log);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printDataImportLog({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printDataImportLog(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveDataImportLog({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["import_id"] === "undefined" || body["import_id"] == null || body["import_id"] == "") {
                delete body["import_id"];
                response = await createDataImportLogs({ body: body, headers: config.headers });
            } else {
                let import_id = body["import_id"];
                delete body["import_id"];
                response = await updateDataImportLogs({ body: body, headers: config.headers }, import_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteDataImportLog({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteDataImportLogs(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    async fetchDataImportTableFields({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getDataImportTableFields(body.table_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageDataImportLogs(state, page) {
        state.page = page;
    },
    setDataImportLogs(state, data_import_logs) {
        state.data_import_logs = data_import_logs;
    },
    setSelectedDataImportLog(state, data_import_log) {
        state.selectedDataImportLog = data_import_log;
    },
    resetSelectedDataImportLog(state) {
        for (const key in state.selectedDataImportLog) {
            if (key in state.rules_data_import_logs) {
                state.selectedDataImportLog[key] =
                    state.rules_data_import_logs[key].default_value == "null" ? null : state.rules_data_import_logs[key].default_value;
            }
        }
    },
    resetDataImportLogs(state) {
        state.page = {};
        state.form = {};
        state.data_import_logs = [];
        state.selectedDataImportLog = {
            import_id: null,
            company_id: "",
            data_import_log_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            data_import_log_details: [],
        };
        state.data_import_logs_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
